var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 110C73.2975 110 63 99.7026 63 87C63 74.2975 73.2975 64 86 64C98.7025 64 109 74.2975 109 87C109 99.7026 98.7025 110 86 110Z",
    fill: "url(#paint0_linear_45_65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C-7.24234e-07 13.4315 13.4315 5.31393e-06 30 4.5897e-06L135 0C135 16.5685 121.569 30 105 30L0 30Z",
    fill: "url(#paint1_linear_45_65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 38C16.5685 38 30 51.4315 30 68V173C13.4315 173 0 159.569 0 143V38Z",
    fill: "url(#paint2_linear_45_65)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143 6.08003e-06C159.569 6.08003e-06 173 13.4315 173 30V135C156.431 135 143 121.569 143 105V6.08003e-06Z",
    fill: "url(#paint3_linear_45_65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173 143C173 159.569 159.569 173 143 173H38C38 156.431 51.4315 143 68 143H173Z",
    fill: "url(#paint4_linear_45_65)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_65",
    x1: -12.5,
    y1: -0.00000213685,
    x2: 204,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_65",
    x1: -12.5,
    y1: -0.00000213685,
    x2: 204,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_65",
    x1: -12.5,
    y1: -0.00000213685,
    x2: 204,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_65",
    x1: -12.5,
    y1: -0.00000213685,
    x2: 204,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_45_65",
    x1: -12.5,
    y1: -0.00000213685,
    x2: 204,
    y2: 173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141EFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.63557bec6106ce2772d1fd698dae9b84.svg";
export { ForwardRef as ReactComponent };